<template>
  <div class="order-vc-info" v-loading="loading">
    <div class="disable-cover" v-if="orderStatus === OrderDeleted" />
    <basic-form
      ref="orderVCInfo"
      title="VC Info"
      :mode="mode"
      :form-params="whatToShow"
    >
      <template v-slot:actions>
        <el-button
          size="small"
          type="primary"
          :disabled="orderStatus === OrderDeleted"
          plain
          @click="editing = true"
          v-if="!editing && editable"
        >
          Edit
        </el-button>
        <el-button
          size="small"
          type="primary"
          plain
          @click="saveInfo"
          v-if="editing && editable"
        >
          Save
        </el-button>
        <el-button
          size="small"
          type="danger"
          plain
          @click="editing = false"
          v-if="editing && editable"
        >
          Cancel
        </el-button>
        <el-button
          size="small"
          type="primary"
          plain
          @click="goToOrderDetail(orderNo)"
          v-if="checkDetail"
        >
          Detail
        </el-button>
      </template>
    </basic-form>
  </div>
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
import { FormModes } from '@/core/configs/types'
// msg
import PagesMessage from '@/core/message/pages'
// apis
import { modifyOrder } from '@/api/order'
// models
import {
  OrderVCInfoWrapUp,
  OrderVCInfoModifyForm,
  OrderDeleted
} from '@/core/models/order'
// mixin
import { pageJumps } from '@/core/mixin/pages'
// components
import BasicForm from '@/components/common/BasicForm.vue'
export default {
  name: 'OrderVCInfo',
  components: { BasicForm },
  mixins: [pageJumps],
  props: {
    orderId: {
      type: String,
      required: true
    },
    orderStatus: {
      type: String,
      default: ''
    },
    orderVC: {
      type: Object,
      default: null
    },
    editable: {
      type: Boolean,
      default: true
    },
    checkDetail: {
      type: Boolean,
      default: false
    },
    mode: {
      type: Object,
      default: () => FormModes.SPARSE
    }
  },
  data() {
    return {
      FormModes,
      OrderDeleted,
      loading: false,
      editing: false
    }
  },
  computed: {
    whatToShow() {
      return this.editing ? this.editInfo : this.viewInfo
    },
    viewInfo() {
      return OrderVCInfoWrapUp(this.orderVC)
    },
    editInfo() {
      const form = cloneDeep(OrderVCInfoModifyForm)
      Object.values(form).forEach(one => {
        one.value = this.orderVC[one.key]
      })
      return form
    },
    orderNo() {
      return this.order.no
    }
  },
  methods: {
    saveInfo() {
      const [passed, orderVCInfo] = this.$refs.orderVCInfo.validateAllInputs()
      if (passed) {
        this.$confirm('Update Order VC Info?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          modifyOrder(this.orderId, {
            vcInfo: orderVCInfo
          }).then(res => {
            if (res) {
              this.editing = false
              PagesMessage.emit(PagesMessage.eventMap.REFRESH_ORDER_DETAIL)
            }
          })
        })
      }
    }
  },
  mounted() {}
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.order-vc-info {
  position: relative;
}
</style>
